module.exports = __webpack_public_path__ + "static/media/home-main-image.a10699ff.png";